export const companiesCompanyIdAppGroupPermissionSetsPermissionSetId =
  "/companies/:company_id/app_group_permission_sets/permission_set/:id";
